<template>
  <aside 
    :class="['mcart',{'mcart--open': isCartOpen}]"
    aria-modal="true"
    role="modal"
    tabindex="0"
  >
  <CartBody
    :cartData="data"
    :isCartOpen="isCartOpen"
    @on-toggle="toggle"
  />
  </aside>
</template>

<script setup>
  import { ref, onBeforeMount } from 'vue';
  import CartBody from './components/cart-body.vue'

  var isCartOpen = ref(false);
  const overlay = new window.Overlay();

  const props = defineProps({
    data: {
      type: Object,
      default: () => ({})
    }
  })

  onBeforeMount(async () => {
    // Setting window function for toggle
    window.openCart = toggle;
  })

  function toggle(_open) {
    const op = typeof _open === "boolean" ? _open : !isCartOpen.value;
    isCartOpen.value = op;
    let bodyStyle = document.body.style;

    if (op){
      overlay.show();
      bodyStyle.overflow = 'hidden'
    }else{
      overlay.hide();
      bodyStyle.overflow = 'auto'
    } 
  }

  overlay.on('cancel', () => {
    toggle(false)
  });
</script>